import { render } from "./ScreenSizePicker.vue?vue&type=template&id=c3c98818"
import script from "./ScreenSizePicker.vue?vue&type=script&lang=js"
export * from "./ScreenSizePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__